import { FC, useEffect, useState, useMemo } from 'react'
import { Grid, GridItem } from '@chakra-ui/react'
import CustomTable from '../../../components/CustomTable'
import { ColumnDef, SortingState } from '@tanstack/react-table'
import Empty from '../../../components/Empty'
import { useNavigate } from 'react-router-dom'
import _ from 'lodash'
import { useSnapshot } from 'valtio'
import useSWR from 'swr'

import tableStore from '../../../lib/store/product_table'
import TableFilter, { ITableFilter } from '../../../components/TableFilter'
import { IDataResponse, serialize } from '../../../network/request'
import Gaps from '../../../components/Gaps'
import ProductService, { Product } from '../../../network/services/product'

const ProductTable: FC<{ total: number; overridePage?: number }> = ({
  total,
  overridePage,
}) => {
  const navigate = useNavigate()
  const { state } = useSnapshot(tableStore)
  const [currentFilters, setCurrentFilters] = useState<any>(null)
  const [selectedRowKeys, setSelectedRowKeys] = useState<any[]>([])
  const [visible, setVisible] = useState(false)

  const setPage = (page: number) => tableStore.state.currentPage = page
  const setSize = (size: number) => tableStore.state.pageSize = size

  const [sorting, setSorting] = useState<SortingState>([])
  if (sorting.length > 0) 
    tableStore.state.sort = `${sorting[0].id}:${sorting[0].desc ? 'desc': 'asc'}`

  const { data: response } = useSWR<IDataResponse<Product>>(
    serialize(ProductService.getAll, {
      page: overridePage ?? state.currentPage,
      limit: state.pageSize,
      sort: state.sort ?? 'created_at:desc',
      refresh: state.refresh,
      ...state.filters,
    })
  )
  const rows = response ? ProductService.toRow(response) : []
  const lastPage = response?.meta?.last_page ? response?.meta?.last_page : 1

  const columns = useMemo<ColumnDef<Product, any>[]>(
    () => [
      {
        id: 'id',
        accessorKey: 'id',
        header: 'ID',
      },
      {
        id: 'external_id',
        accessorKey: 'external_id',
        header: 'Shopify ID',
      },
      {
        id: 'name',
        accessorKey: 'name',
        header: '商品名',
      },
      {
        id: 'published_At',
        accessorFn: (row) => (row.published_at ? '公開' : '非公開'),
        header: '公開状態',
      },
      {
        id: 'updated_at',
        accessorKey: 'updated_at',
        header: '最終更新日',
        cell: (info) => `${info.getValue().toLocaleString()}`,
      },
    ],
    []
  )

  // content={
  //   initialValue.variants.length > 0
  //     ? initialValue.variants.map((item) => item.name).join(',')
  //     : '-'
  // }

  const filterColumns: ITableFilter[] = [{ key: 'name', name: '商品名' }]
  filterColumns.forEach((item) => {
    if (
      tableStore.state?.filters &&
      Object.keys(tableStore.state.filters).includes(item.key)
    ) {
      item.default_value = tableStore.state.filters[item.key]
      item.default = true
    }
  })

  useEffect(() => {
    if (currentFilters != null) {
      tableStore.state.filters = { ...currentFilters }
      tableStore.state.currentPage = 1
    }
  }, [currentFilters])

  const handleMenuClick = (e: any) => {
    setVisible(true)
    // setModalType(e.key)
  }

  const batchDeleteRows = async () => {
    // try {
    //   for (const id of selectedRowKeys) {
    //     const { data } = await ReviewService.remove(id)
    //     if (data?.success === true) {
    //       message.success(`Delete source success`)
    //     } else {
    //       message.error(`Delete source ${id} failed`)
    //     }
    //     tableStore.state.refresh = Math.random()
    //   }
    //   setVisible(false)
    // } catch (e) {
    //   message.error({ content: e.message, className: 'message-error' })
    // }
  }

  // const ActionModal: FC = () => {
  //   return (
  //     <Modal
  //       title={`Remove ${selectedRowKeys.length} reviews`}
  //       open={visible}
  //       onOk={() => {
  //         switch(modalType){
  //           case 'delete':
  //             batchDeleteRows()
  //             break;
  //           case 'publish':

  //         }
  //       }}
  //       onCancel={() => {
  //         setVisible(false)
  //       }}
  //       okText='Delete'
  //       cancelText='Cancel'
  //     >
  //       This can't be undone
  //     </Modal>
  //   )
  // }

  return (
    <>
      {/* <ActionModal /> */}

      <Grid templateColumns='repeat(2, 1fr)' gap={2}>
        <GridItem>
          {/* {selectedRowKeys?.length > 0 ? (
            <Dropdown
              menu={{
                items: [
                  {
                    label: 'Delete',
                    onClick: handleMenuClick,
                    key: 'delete',
                  },
                ],
              }}
              trigger={['click']}
            >
              <Button type='primary'>
                More Actions <CaretDownOutlined />
              </Button>
            </Dropdown>
          ) : (
            <></>
          )} */}
        </GridItem>
        <GridItem colSpan={2}>
          <TableFilter
            dropdowns={[]}
            columns={filterColumns}
            hasDate={false}
            setCurrentFilters={setCurrentFilters}
          />
          <Gaps level={3} />
        </GridItem>
      </Grid>

      {rows?.length > 0 ? (
        <CustomTable
          {...{
            data: rows,
            columns,
            lastPage,
            page: state.currentPage,
            setPage,
            size: state.pageSize,
            setSize,
            sorting,
            setSorting,
          }}
        />
      ) : (
        <Empty description={'データが見つかりませんでした'} />
      )}
    </>
  )
}

export default ProductTable
